<div class="content-header bg-primary">
  <mat-toolbar color="primary" class="px-2 page-header-toolbar users-toolbar-flex">
    <div class="users-toolbar-title">
      <h1>Users</h1>
    </div>
    <div class="users-toolbar-actions">
      <div class="page-header-control search-control">
        <mat-icon>search</mat-icon>
        <mat-form-field>
          <mat-label>Filter Users</mat-label>
          <input #searchBar matInput placeholder="By email, name, etc..." (keyup)="filter($event)"
            [class.show]="true" />
        </mat-form-field>
      </div>
      <div>
        <button color="primary" mat-button class="users-add-button" (click)="createEditUser()">
          <mat-icon>add</mat-icon>
          <span>User</span>
        </button>
      </div>
    </div>
  </mat-toolbar>

  <div class="p-2">
    <mat-card appearance="outlined" style="padding: 0">
      <mat-card-content #tableContainer>
        <table mat-table #table [dataSource]="usersDataSource" matSort class="table">
          <ng-container matColumnDef="UserName">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              Username
            </th>
            <td *matCellDef="let user" mat-cell>{{ user.userName }}</td>
          </ng-container>
          <ng-container matColumnDef="FirstName, LastName">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
            <td *matCellDef="let user" mat-cell>
              {{ user.firstName }} {{ user.lastName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th *matHeaderCellDef mat-header-cell mat-sort-header disabled>
              Role
            </th>
            <td *matCellDef="let user" mat-cell>
              {{ getRoleDisplayName(user) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Retailer">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              Retailer
            </th>
            <td *matCellDef="let user" mat-cell>{{ user.retailerName }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell mat-sort-header disabled></th>
            <td *matCellDef="let user" mat-cell>
              <button color="primary" mat-button (click)="createEditUser(user)">
                <span>Edit</span>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="headers"></tr>
          <tr mat-row *matRowDef="let users; columns: headers"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 15, 25, 50]" [pageSize]="10" showFirstLastButtons>
        </mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</div>